module.exports = __webpack_public_path__ + "static/media/yt-logo.e0f96ab4.jpg";